export default __webpack_public_path__ + "static/media/salad-min.42d20c41.png";